import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../AxiosInstance/axiosInstance";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";

export const createVideoCategory = createAsyncThunk(
  "videoCategory/createVideo",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.post(
        `/v1/admin/videoCategory/create_videoCategory`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getVideoCategory = createAsyncThunk(
  "videoCategory/getAll",
  async (
    {
      categoryId,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstance.get(
        `/v1/admin/videoCategory/get_videoCategory`,
        {
          params: {
            categoryId,
            status,
            search,
            page: Number(page),
            limit: Number(limit),
            startDate: startDate || undefined,
            endDate: endDate || undefined,
            paginate: paginate === "true",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const deleteVideoCategory = createAsyncThunk(
  "videoCategory/delete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.delete(
        `/v1/admin/videoCategory/delete_videoCategory/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteVideoCategory = createAsyncThunk(
  "videoCategory/undoDelete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstance.put(
        `/v1/admin/videoCategory/undodelete_videoCategory/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getVideoCategoryByIdData = createAsyncThunk(
  "videoCategory/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstance.get(
        `/v1/admin/videoCategory/getSingle_videoCategory/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateVideoCategory = createAsyncThunk(
  "videogalleryCategory/update",
  async ({ _id, formData }, thunkAPI) => {
    try {
      const response = await axiosInstanceJson.put(
        `/v1/admin/videoCategory/update_videoCategory/${_id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
